import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3Icon, DollarSignIcon, TrendingUpIcon, CheckIcon, ShieldIcon, ArrowRightIcon } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
const RollingPayDashboard = () => {
  return <div className="max-w-4xl mx-auto" data-id="element-1172">
      <div className="mb-6" data-id="element-1173">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-1174">
          RollingPay Business Dashboard
        </h1>
        <p className="text-neutral-400" data-id="element-1175">
          Manage your business finances and access capital
        </p>
      </div>
      {/* Business Profile Summary */}
      <section className="mb-8" data-id="element-1176">
        <Card data-id="element-1177">
          <div className="flex flex-col md:flex-row md:items-center" data-id="element-1178">
            <div className="flex-1" data-id="element-1179">
              <div className="flex items-center mb-4" data-id="element-1180">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold mr-4" data-id="element-1181">
                  AC
                </div>
                <div data-id="element-1182">
                  <h2 className="text-xl font-bold" data-id="element-1183">Amani Cafe</h2>
                  <p className="text-sm text-neutral-400" data-id="element-1184">
                    Coffee Shop • Kuala Lumpur
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1185">
                <div className="p-3 bg-neutral-50 rounded-lg" data-id="element-1186">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-1187">
                    Business Maturity
                  </div>
                  <div className="font-medium" data-id="element-1188">3+ Years</div>
                </div>
                <div className="p-3 bg-neutral-50 rounded-lg" data-id="element-1189">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-1190">
                    Monthly Revenue
                  </div>
                  <div className="font-medium" data-id="element-1191">RM 45,000</div>
                </div>
                <div className="p-3 bg-neutral-50 rounded-lg" data-id="element-1192">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-1193">
                    Credit Score
                  </div>
                  <div className="font-medium text-success" data-id="element-1194">Excellent</div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Financing Options Toggle */}
      <section className="mb-6" data-id="element-1195">
        <div className="flex justify-between items-center" data-id="element-1196">
          <h2 className="text-xl font-bold" data-id="element-1197">Business Financing</h2>
        </div>
      </section>
      {/* Micro-Sukuk Eligibility */}
      <section className="mb-8" data-id="element-1198">
        <Card data-id="element-1199">
          <div className="flex items-center mb-6" data-id="element-1200">
            <div className="w-12 h-12 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-4" data-id="element-1201">
              <ShieldIcon className="w-6 h-6 text-primary" data-id="element-1202" />
            </div>
            <div data-id="element-1203">
              <h3 className="font-bold text-lg" data-id="element-1204">Community Micro-Sukuk</h3>
              <p className="text-neutral-400" data-id="element-1205">
                Shariah-compliant financing with community impact
              </p>
            </div>
            <div className="ml-auto bg-success bg-opacity-10 text-success px-3 py-1 rounded-full text-sm font-medium" data-id="element-1206">
              Eligible
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1207">
            <div data-id="element-1208">
              <h4 className="font-medium mb-3" data-id="element-1209">Eligibility Criteria</h4>
              <div className="space-y-3" data-id="element-1210">
                <div className="flex items-start" data-id="element-1211">
                  <div className="mt-0.5 mr-2 w-5 h-5 rounded-full bg-success bg-opacity-10 flex items-center justify-center" data-id="element-1212">
                    <CheckIcon className="w-3 h-3 text-success" data-id="element-1213" />
                  </div>
                  <div data-id="element-1214">
                    <div className="font-medium" data-id="element-1215">Business Age</div>
                    <div className="text-sm text-neutral-400" data-id="element-1216">
                      Minimum 2 years in operation
                    </div>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1217">
                  <div className="mt-0.5 mr-2 w-5 h-5 rounded-full bg-success bg-opacity-10 flex items-center justify-center" data-id="element-1218">
                    <CheckIcon className="w-3 h-3 text-success" data-id="element-1219" />
                  </div>
                  <div data-id="element-1220">
                    <div className="font-medium" data-id="element-1221">Monthly Revenue</div>
                    <div className="text-sm text-neutral-400" data-id="element-1222">
                      Minimum RM 20,000
                    </div>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1223">
                  <div className="mt-0.5 mr-2 w-5 h-5 rounded-full bg-success bg-opacity-10 flex items-center justify-center" data-id="element-1224">
                    <CheckIcon className="w-3 h-3 text-success" data-id="element-1225" />
                  </div>
                  <div data-id="element-1226">
                    <div className="font-medium" data-id="element-1227">Credit History</div>
                    <div className="text-sm text-neutral-400" data-id="element-1228">
                      Good standing with no defaults
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-neutral-50 rounded-lg p-4" data-id="element-1229">
              <h4 className="font-medium mb-3" data-id="element-1230">Available Financing</h4>
              <div className="text-3xl font-bold text-primary mb-2" data-id="element-1231">
                RM 50,000
              </div>
              <div className="text-sm text-neutral-400 mb-4" data-id="element-1232">
                Flexible terms from 3-12 months • Profit rates from 5% p.a.
              </div>
              <Link to="/demo/sukuk-initiation" data-id="element-1233">
                <Button variant="primary" fullWidth icon={<ArrowRightIcon className="w-4 h-4" data-id="element-1235" />} iconPosition="right" data-id="element-1234">
                  Apply for Micro-Sukuk
                </Button>
              </Link>
            </div>
          </div>
          <div className="bg-secondary bg-opacity-5 border border-secondary border-opacity-10 rounded-lg p-4" data-id="element-1236">
            <h4 className="font-medium text-secondary mb-2" data-id="element-1237">
              Why Community Micro-Sukuk?
            </h4>
            <ul className="text-sm space-y-2" data-id="element-1238">
              <li className="flex items-start" data-id="element-1239">
                <div className="mt-1 mr-2 w-4 h-4 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center" data-id="element-1240">
                  <CheckIcon className="w-3 h-3 text-secondary" data-id="element-1241" />
                </div>
                <span data-id="element-1242">Shariah-compliant financing structure</span>
              </li>
              <li className="flex items-start" data-id="element-1243">
                <div className="mt-1 mr-2 w-4 h-4 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center" data-id="element-1244">
                  <CheckIcon className="w-3 h-3 text-secondary" data-id="element-1245" />
                </div>
                <span data-id="element-1246">Direct connection to impact-focused investors</span>
              </li>
              <li className="flex items-start" data-id="element-1247">
                <div className="mt-1 mr-2 w-4 h-4 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center" data-id="element-1248">
                  <CheckIcon className="w-3 h-3 text-secondary" data-id="element-1249" />
                </div>
                <span data-id="element-1250">
                  Build community relationships through investor rewards
                </span>
              </li>
              <li className="flex items-start" data-id="element-1251">
                <div className="mt-1 mr-2 w-4 h-4 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center" data-id="element-1252">
                  <CheckIcon className="w-3 h-3 text-secondary" data-id="element-1253" />
                </div>
                <span data-id="element-1254">
                  Transparent, ethical funding source with fixed terms
                </span>
              </li>
            </ul>
          </div>
        </Card>
      </section>
      {/* Quick Links */}
      <section data-id="element-1255">
        <h2 className="text-xl font-bold mb-4" data-id="element-1256">Quick Access</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1257">
          <Card className="text-center" data-id="element-1258">
            <div className="flex flex-col items-center" data-id="element-1259">
              <div className="w-12 h-12 rounded-full bg-neutral-100 flex items-center justify-center mb-3" data-id="element-1260">
                <BarChart3Icon className="w-6 h-6 text-neutral-500" data-id="element-1261" />
              </div>
              <h3 className="font-medium mb-2" data-id="element-1262">Financial Reports</h3>
              <p className="text-sm text-neutral-400 mb-4" data-id="element-1263">
                View your business performance metrics
              </p>
              <Button variant="ghost" size="sm" data-id="element-1264">
                View Reports
              </Button>
            </div>
          </Card>
          <Card className="text-center" data-id="element-1265">
            <div className="flex flex-col items-center" data-id="element-1266">
              <div className="w-12 h-12 rounded-full bg-neutral-100 flex items-center justify-center mb-3" data-id="element-1267">
                <DollarSignIcon className="w-6 h-6 text-neutral-500" data-id="element-1268" />
              </div>
              <h3 className="font-medium mb-2" data-id="element-1269">Payment History</h3>
              <p className="text-sm text-neutral-400 mb-4" data-id="element-1270">
                Review your transaction records
              </p>
              <Button variant="ghost" size="sm" data-id="element-1271">
                View Payments
              </Button>
            </div>
          </Card>
          <Card className="text-center" data-id="element-1272">
            <div className="flex flex-col items-center" data-id="element-1273">
              <div className="w-12 h-12 rounded-full bg-neutral-100 flex items-center justify-center mb-3" data-id="element-1274">
                <TrendingUpIcon className="w-6 h-6 text-neutral-500" data-id="element-1275" />
              </div>
              <h3 className="font-medium mb-2" data-id="element-1276">Growth Planning</h3>
              <p className="text-sm text-neutral-400 mb-4" data-id="element-1277">
                Set goals and track your progress
              </p>
              <Button variant="ghost" size="sm" data-id="element-1278">
                View Plan
              </Button>
            </div>
          </Card>
        </div>
      </section>
    </div>;
};
export default RollingPayDashboard;